module.exports = __webpack_public_path__ + "img/melissa-calendario1.b6bec6da.png";